(function () {
  'use strict';
  function searchTerms(value, country, mode = 'collection') {
    if (mode === 'store') return String(value || '').trim();
    const suffix = `) AND tag:${country}`;
    const text = String(value || '').trim();
    if (text === `tag:${country}`) return '';
    return text.startsWith('(') && text.endsWith(suffix)
      ? text.slice(1, -suffix.length).trim() : text;
  }
  function scopeQuery(value, country, mode = 'collection', allowed = true) {
    if (allowed !== true || !['store', 'collection', 'tag_search'].includes(mode)) throw new Error('Invalid catalog scope');
    if (mode === 'store') return searchTerms(value, country, mode);
    if (!/^[A-Z]{2}$/.test(country)) throw new Error('Invalid search country');
    const terms = searchTerms(value, country).replace(/[():]/g, ' ').replace(/\b(?:AND|OR|NOT)\b/g, ' ').replace(/\s+/g, ' ').trim();
    return terms ? `(${terms}) AND tag:${country}` : `tag:${country}`;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { searchTerms, scopeQuery };
    return;
  }
  const forms = Array.from(document.querySelectorAll('[data-hlx-search-country]'));
  const validForms = forms.filter(form => form.dataset.marketAllowed === 'true'
    && Boolean(form.dataset.storeKey)
    && ['store', 'collection', 'tag_search'].includes(form.dataset.catalogMode));
  validForms.forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(form.action, window.location.origin);
      url.search = new URLSearchParams(new FormData(form)).toString();
      url.searchParams.set('q', scopeQuery(form.elements.q.value, form.dataset.hlxSearchCountry, form.dataset.catalogMode));
      window.location.assign(url.href);
    });
  });
  const form = validForms[0];
  if (!form) return;
  // Preserve old /search links using the same complete Bulgarian catalog filter.
  if (form.dataset.storeKey === 'bg_hlp' && /\/search\/?$/.test(window.location.pathname)) {
    const target = new URL(form.action, window.location.origin);
    target.search = window.location.search;
    target.searchParams.delete('type');
    target.searchParams.delete('page');
    window.location.replace(target.href);
    return;
  }

  const country = form.dataset.hlxSearchCountry;
  const mode = form.dataset.catalogMode;
  const allowed = form.dataset.marketAllowed === 'true' && Boolean(form.dataset.storeKey);
  if (!allowed || !['store', 'collection', 'tag_search'].includes(mode)) return;
  if (document.querySelector('[data-hlx-search-results], [data-hlx-page-catalog][data-search-mode="true"]')) {
    const url = new URL(window.location.href);
    if (url.searchParams.has('q')) {
      const raw = url.searchParams.get('q');
      const scoped = scopeQuery(raw, country, mode, allowed);
      if (raw !== scoped || url.searchParams.get('type') !== 'product') {
        url.searchParams.set('q', scoped);
        url.searchParams.set('type', 'product');
        url.searchParams.delete('page');
        window.location.replace(url.href);
      }
    }
  }
})();
